<template>
    <!-- The house's headline numbers: sleeping capacity only.
         This was a Stays/Weddings toggle, then briefly a two-row labelled bar
         carrying both. Wedding capacity now lives in the Weddings section with
         the rest of the wedding information, which keeps this bar doing one job
         and reading as it always did.
         Each stat needs a value and the bar needs at least one, so a house
         missing the meta gets no empty row and no empty box. -->
    <div
        v-if="hasStats"
        class="border border-brand-2-950/10 rounded-xl p-5 xl:px-7 xl:py-4"
    >
        <ul class="flex flex-wrap gap-x-4 sm:gap-x-5 gap-y-2.5 text-xsss sm:text-xs font-semibold text-brand-2-950">
            <li
                v-if="sleeps"
                class="flex items-center gap-1.5 sm:gap-2.5"
            >
                <span
                    class="w-[16px] sm:w-[18px]"
                    v-html="PeopleIcon"
                ></span>
                {{ sleeps }}
                Guests
            </li>

            <li
                v-if="bedrooms"
                class="flex items-center gap-1.5 sm:gap-2.5"
            >
                <span
                    class="w-[16px] sm:w-[18px]"
                    v-html="BedIcon"
                ></span>
                {{ bedrooms }}
                Bedrooms
            </li>

            <li
                v-if="bathrooms"
                class="flex items-center gap-1.5 sm:gap-2.5"
            >
                <span
                    class="w-[16px] sm:w-[18px]"
                    v-html="BathIcon"
                ></span>
                {{ bathrooms }}
                Bathrooms
            </li>
        </ul>
    </div>
</template>

<script setup>
    import { computed } from 'vue';

    import PeopleIcon from '@img/icons/people.svg?raw';
    import BedIcon from '@img/icons/bed.svg?raw';
    import BathIcon from '@img/icons/bath.svg?raw';

    const props = defineProps({
        sleeps: Number,
        bedrooms: Number,
        bathrooms: Number,
    });

    const hasStats = computed(() => Boolean(props.sleeps || props.bedrooms || props.bathrooms));
</script>
